import React from 'react'

const StoreLocator = () => (
  <svg width="15" height="21" viewBox="0 0 15 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.5 0C3.36071 0 0 3.36071 0 7.5C0 8.70571 0.627857 10.405 1.54536 12.1796C3.56714 16.0896 6.93536 20.4375 6.93536 20.4375C7.07071 20.6121 7.27929 20.7143 7.5 20.7143C7.72071 20.7143 7.92929 20.6121 8.06464 20.4375C8.06464 20.4375 11.4329 16.0896 13.4546 12.1796C14.3721 10.405 15 8.70571 15 7.5C15 3.36071 11.6393 0 7.5 0ZM7.5 4.28571C5.72607 4.28571 4.28571 5.72607 4.28571 7.5C4.28571 9.27393 5.72607 10.7143 7.5 10.7143C9.27393 10.7143 10.7143 9.27393 10.7143 7.5C10.7143 5.72607 9.27393 4.28571 7.5 4.28571Z" fill="currentColor"/>
  </svg>
)

export default StoreLocator